<div class="images-of-damage-svg images-of-damage-svg--desktop">
    <svg width="450px" height="240px" viewBox="0 0 450 240">
        <title>Images/vehicle-desktop</title>
        <g [attr.d]="" app-question-damage-image-front id="Images/vehicle-desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        </g>
    </svg>
</div>
